import { createIcon } from '@chakra-ui/react';

export const ExportIcon = createIcon({
  displayName: 'ExportIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="12"
        // height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path d="M6.5 5.49844L10.6 1.39844L6.5 5.49844Z" fill="#6E6789" />
        <path
          d="M6.5 5.49844L10.6 1.39844"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.9996 3.4V1H8.59961" fill="#6E6789" />
        <path
          d="M10.9996 3.4V1H8.59961"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
